import {ALTERAR_COMPRADOR_IDA, ALTERAR_PASSAGEIRO_IDA} from '../types'

export function alterarPassageiroIda (passageiro) {
  return {
    type: ALTERAR_PASSAGEIRO_IDA,
    payload: passageiro
  }
}

export function alterarCompradorIda (passageiro) {
  return {
    type: ALTERAR_COMPRADOR_IDA,
    payload: passageiro
  }
}
